import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axiosInstance from "../utils/axios";
import "../styles/TicketPage.scss";

export default function TicketPage() {
    const { ticket_token } = useParams();
    const [ticket, setTicket] = useState(null);

    useEffect(() => {
        async function fetchTicket() {
            try {
                const { data } = await axiosInstance.get(
                    `/booking/ticket/link-verify/${ticket_token}`
                );
                setTicket(data);
            } catch (err) {
                console.error(err);
            }
        }
        fetchTicket();
    }, [ticket_token]);

    if (!ticket) {
        return <div className="ticket-loading">Loading your ticket…</div>;
    }

    // ✅ Format date (e.g. 12 Aug 2025)
    const formattedDate = new Date(ticket.show_date).toLocaleDateString(
        "en-US",
        {
            day: "numeric",
            month: "short",
            year: "numeric",
        }
    );

    // ✅ Group seats by section
    const seatsBySection = ticket.seats.reduce((acc, seat) => {
        acc[seat.section] = acc[seat.section] || [];
        acc[seat.section].push(seat);
        return acc;
    }, {});

    return (
        <div className="ticket-page">
            <div className="ticket-card">
                <h1 className="movie-title">{ticket.movie}</h1>

                <div className="ticket-info">
                    <div>
                        <span>Theatre</span>
                        <p>{ticket.theatre}</p>
                    </div>
                    <div>
                        <span>Screen</span>
                        <p>{ticket.screen}</p>
                    </div>
                    <div>
                        <span>Date</span>
                        <p>{formattedDate}</p>
                    </div>
                    <div>
                        <span>Time</span>
                        <p>{ticket.show_time}</p>
                    </div>
                </div>

                <div className="seat-section">
                    <h3>Seats</h3>

                    {Object.entries(seatsBySection).map(
                        ([section, seats]) => (
                            <div key={section} className="seat-group">
                                <div className="section-title">
                                    Section {section}
                                </div>

                                <div className="seat-list">
                                    {seats.map((s, i) => (
                                        <span key={i} className="seat-chip">
                                            {s.block}-{s.row}-{s.number}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        )
                    )}
                </div>

                <div className="ticket-footer">
                    <p>🎟️ Please show this ticket at entry</p>
                </div>
            </div>
        </div>
    );
}
